<template>
  <admin-page-frame>
    <el-button size="mini" icon="el-icon-back" @click="$router.push('/admin/schools/class')">返回列表</el-button>
    <div v-loading="loading" style="margin-top: 16px;">
      <el-descriptions v-if="classInfo.id" title="班级信息" :column="2" border size="small" style="margin-bottom: 20px;">
        <el-descriptions-item label="班级编码">{{ classInfo.classCode }}</el-descriptions-item>
        <el-descriptions-item label="班级名称">{{ classInfo.className }}</el-descriptions-item>
        <el-descriptions-item label="班型">{{ classInfo.classType === 'private' ? '一对一' : '班课' }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ classStatusLabel(classInfo.status) }}</el-descriptions-item>
        <el-descriptions-item label="关联课程">{{ courseName(classInfo.courseId) }}</el-descriptions-item>
        <el-descriptions-item label="授课教师">{{ teacherName(classInfo.teacherId) }}</el-descriptions-item>
        <el-descriptions-item label="在班人数">{{ studentCount }} / {{ classInfo.maxStudents }}</el-descriptions-item>
        <el-descriptions-item label="开始日期">{{ classInfo.startDate || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div style="margin-bottom: 12px; display: flex; gap: 8px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAddStudent">添加学员</el-button>
        <el-button size="mini" icon="el-icon-date" @click="goSchedule">排课管理</el-button>
      </div>
      <h3 style="margin: 0 0 12px; font-size: 15px; font-weight: 600;">在班学员（{{ studentCount }}）</h3>
      <el-table :data="students" :border="false" size="small" style="width: 100%;" empty-text="暂无在班学员">
        <el-table-column prop="studentCode" label="学号" min-width="120" />
        <el-table-column prop="studentName" label="姓名" min-width="100" />
        <el-table-column label="性别" width="70" align="center"><template slot-scope="{ row }">{{ genderLabel(row.gender) }}</template></el-table-column>
        <el-table-column prop="parentPhone" label="家长手机" min-width="120" />
        <el-table-column label="操作" width="160" align="center" class-name="admin-pc-table-actions-col">
          <template slot-scope="{ row }">
            <div class="admin-pc-table-actions">
              <el-button type="text" size="mini" @click="$router.push('/admin/schools/student/' + row.id)">详情</el-button>
              <el-button type="text" size="mini" class="admin-pc-table-actions__danger" @click="handleRemove(row)">移出</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="添加学员到班级" :visible.sync="addVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="80px" size="small">
        <el-form-item label="学员">
          <el-select v-model="addStudentId" filterable remote :remote-method="searchStudents" placeholder="搜索姓名/学号/手机" style="width: 100%;">
            <el-option v-for="s in studentOptions" :key="s.id" :label="s.studentName + '（' + s.studentCode + '）'" :value="s.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="adding" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import {
  addSchoolClassStudent,
  fetchSchoolClassDetail,
  fetchSchoolCourseOptions,
  fetchSchoolStudents,
  fetchSchoolTeacherOptions,
  removeSchoolClassStudent
} from '@/api/h5-admin-schools'
import './schools-admin.less'
export default {
  name: 'SchoolsClassDetail',
  components: { AdminPageFrame },
  data() {
    return {
      loading: false, adding: false, addVisible: false, addStudentId: null,
      classInfo: {}, students: [], studentCount: 0, courseOptions: [], teacherOptions: [], studentOptions: []
    }
  },
  computed: { classId() { return this.$route.params.id } },
  created() { this.loadOptions(); this.loadDetail() },
  methods: {
    loadOptions() {
      fetchSchoolCourseOptions().then(list => { this.courseOptions = list || [] })
      fetchSchoolTeacherOptions().then(list => { this.teacherOptions = list || [] })
    },
    loadDetail() {
      this.loading = true
      fetchSchoolClassDetail(this.classId).then(res => {
        this.classInfo = (res && res.classInfo) || {}
        this.students = (res && res.students) || []
        this.studentCount = (res && res.studentCount) || this.students.length
      }).finally(() => { this.loading = false })
    },
    searchStudents(keyword) {
      if (!keyword) return
      fetchSchoolStudents({ keyword, page: 0, size: 20 }).then(res => { this.studentOptions = (res && res.content) || [] })
    },
    courseName(id) { const c = this.courseOptions.find(x => x.id === id); return c ? c.courseName : (id || '-') },
    teacherName(id) { const t = this.teacherOptions.find(x => x.id === id); return t ? t.teacherName : (id || '-') },
    classStatusLabel(v) { const map = { recruiting: '招生中', ongoing: '进行中', finished: '已结课', closed: '已关闭' }; return map[v] || v || '-' },
    genderLabel(v) { const map = { 0: '未知', 1: '男', 2: '女' }; return map[v] || '-' },
    openAddStudent() { this.addStudentId = null; this.addVisible = true },
    submitAdd() {
      if (!this.addStudentId) { this.$message.warning('请选择学员'); return }
      this.adding = true
      addSchoolClassStudent(this.classId, this.addStudentId).then(() => {
        this.$message.success('已添加')
        this.addVisible = false
        this.loadDetail()
      }).finally(() => { this.adding = false })
    },
    handleRemove(row) {
      this.$confirm('确认将「' + row.studentName + '」移出班级？', '提示', { type: 'warning' }).then(() => {
        removeSchoolClassStudent(this.classId, row.id).then(() => { this.$message.success('已移出'); this.loadDetail() })
      }).catch(() => {})
    },
    goSchedule() { this.$router.push({ path: '/admin/schools/schedule', query: { classId: this.classId, batch: '1' } }) }
  }
}
</script>
